import cx from "classnames"
import * as React from "react"
import * as styles from "./styles.module.scss"

export interface TileBorderSmallProps {
  ctaPrimary?: string
  heading: string
  link: string
  subhead?: string
}

const TileBorderSmall: React.FC<TileBorderSmallProps> = ({
  ctaPrimary,
  heading,
  link,
  subhead,
}) => {
  return (
    <div className={styles.root}>
      <div className={styles.box}>
        <a
          className={styles.button}
          href={link}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className={styles.content}>
            <h5 className={styles.heading}>{heading}</h5>
            {subhead && (
              <p className={styles.subhead}>
                {subhead}
                <i
                  className={cx({
                    [styles.arrow]: true,
                    ["bsk-icon-arrow-stick-right-thicker"]: true,
                  })}
                />
              </p>
            )}
            {ctaPrimary && (
              <span className={styles.linkPrimary}>{ctaPrimary}</span>
            )}
          </div>
        </a>
      </div>
    </div>
  )
}

export default TileBorderSmall
